export default __webpack_public_path__ + "static/media/fullscreen.7614da0b.svg";